import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-twenty-eight',
  templateUrl: './home-twenty-eight.component.html',
  styleUrls: ['./home-twenty-eight.component.scss']
})
export class HomeTwentyEightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
